const initFooter = () => {
  // アコーディオン表示
  const accordionButtons = document.querySelectorAll(".footer-accordion__title");
  accordionButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", !isExpanded);
      if (!isExpanded) {
        button
          .closest(".footer-accordion")
          .classList.add("active");
      } else {
        button
          .closest(".footer-accordion")
          .classList.remove("active");
      }
    });
  });
};
document.addEventListener("DOMContentLoaded", initFooter);